module.exports = __webpack_public_path__ + "img/medal9.8605a8dd.png";